<template>
  <div class="nav-bar flex-between">
    <!-- <router-link to="/home/escort" class="nav-item flex-rowc">陪护业务</router-link>
      <router-link to="/home/management" class="nav-item flex-rowc">管理中心</router-link>
      <router-link to="/home/personal" class="nav-item flex-rowc">个人管理</router-link> -->
    <div
      class="nav-item flex-rowc"
      v-for="(item, index) in navList"
      :key="index"
      @click="handleClick(index)"
    >
      {{ item.name }}
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "NavBar",
  data() {
    return {
      navList: [
        {
          name: "陪护业务",
          path: "/home/escort",
        },
        {
          name: "管理中心",
          path: "/home/management",
        },
        {
          name: "个人管理",
          path: "/home/personal",
        },
      ],
      activeIndex: 0,
    };
  },
  methods: {
    handleClick(index) {
      const { USERINFO } = this.$store.state;
      const roleMap = {
        0: 1,
        1: 2
      };
      const requiredRole = roleMap[index];

      if (requiredRole != undefined) {
        let userRole;
        if (USERINFO && USERINFO.userFunction) {
          userRole = USERINFO.userFunction.role;
        }
        if (!userRole || userRole != requiredRole) {
          this.$toast("暂无权限");
          return;
        }
      }

      const targetPath = this.navList[index].path;
      // 检查目标路由是否和当前路由相同
      if (this.$route.path == targetPath) {
        return;
      }

      this.activeIndex = index;
      this.$router.push(targetPath).catch((error) => {
        if (error.name == 'NavigationDuplicated') {
          // 忽略导航重复错误
          return;
        }
        // 处理其他错误
        console.error(error);
      });
    },
  },
};
</script>
  
  <style scoped lang="less">
.nav-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 150px;
  background: #fff;
  z-index: 100001;
  max-width: 750px;
  margin: auto;
}

.nav-item {
  height: 100%;
  flex: 1;
  font-size: 24px;
  color: #000000;
  cursor: pointer;
  &:nth-child(2) {
    border-left: 1px solid #7a7a7a;
    border-right: 1px solid #7a7a7a;
  }
  &:hover {
    text-decoration: none !important;
  }
}

.nav-item:hover {
  text-decoration: underline;
}
</style>